type VerificationStatus = 'RUNNING' | 'CANCELED' | 'COMPLETED';

export type FuzzyMatchConfidenceLevel = 'PASS' | 'INCONCLUSIVE';

type TaxVerificationFuzzyMatch = {
  expected: string;
  registered: string | null;
  percentage: number;
  status: FuzzyMatchConfidenceLevel;
};

export type TaxIdResult = {
  taxIdNumber: string;
  foundInOfficialDataBase: boolean;
  taxRegistered: boolean;
  isValidFormat: boolean;
  name: TaxVerificationFuzzyMatch | null;
  address: TaxVerificationFuzzyMatch | null;
};

const VERIFICATION_TAX_ID_KEYS = ['vatId', 'tin'] as const;
const ALL_TAX_ID_KEYS = [...VERIFICATION_TAX_ID_KEYS, 'additionalTin'] as const;

type AllVerificationTaxIdKeys = typeof VERIFICATION_TAX_ID_KEYS;
type AllTaxIdKeys = typeof ALL_TAX_ID_KEYS;

export type VerificationTaxIdKey = AllVerificationTaxIdKeys[number];
export type TaxIdKey = AllTaxIdKeys[number];

export type VerificationTaxIdKeys = VerificationTaxIdKey[];
export type TaxIdKeys = TaxIdKey[];

export const isTaxIdKey = (value: string): value is TaxIdKey => ALL_TAX_ID_KEYS.includes(value as TaxIdKey);

export type TaxInfoVerificationResult = Record<VerificationTaxIdKey, TaxIdResult | null>;

export type VerificationResult = {
  status: VerificationStatus;
  countryCode: string;
  result: TaxInfoVerificationResult | null;
};
